export default __webpack_public_path__ + "static/media/6_english.cac018f2.jpg";